import { FeatureFlagsState } from '@/stores/FeatureFlags/state'
import { FeatureFlag } from '@/stores/FeatureFlags/types'

export type FeatureFlagGetters = {
  [K in keyof FeatureFlagsState]: (state: FeatureFlagsState) => FeatureFlagsState[K]
} & {
  isFeatureFlagEnabled: (state: FeatureFlagsState, getters: FeatureFlagGetters) => (key: FeatureFlag) => boolean
  featureFlagsLoaded: boolean
}

export default {
  featureFlags: (state: FeatureFlagsState) => state.featureFlags,
  isFeatureFlagEnabled: (state: FeatureFlagsState, getters: FeatureFlagGetters) => (key: FeatureFlag) => {
    return getters.featureFlagsLoaded && !!state.featureFlags[key]
  },
  featureFlagsLoaded: (state: FeatureFlagsState) => state.loaded,
}
